"use strict";
/**
 * Client-safe utility functions for prompt handling
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileTemplateString = compileTemplateString;
exports.compileEvalPrompt = compileEvalPrompt;
exports.extractPlaceholderNames = extractPlaceholderNames;
const utilities_1 = require("../features/evals/utilities");
function compileTemplateString(template, context) {
    try {
        return template.replace(/\{\{\s*([\p{L}\p{N}_.]+)\s*\}\}/gu, (match, key) => {
            if (!(key in context))
                return match;
            const value = context[key];
            return value === undefined || value === null ? "" : String(value);
        });
    }
    catch {
        return template;
    }
}
function compileEvalPrompt(params) {
    return compileTemplateString(params.templatePrompt, Object.fromEntries(params.variables.map(({ var: key, value }) => [
        key,
        (0, utilities_1.parseUnknownToString)(value),
    ])));
}
/**
 * Extracts placeholder names from prompt messages.
 * This is a client-safe version that doesn't depend on server-side types.
 * @param messages Array of prompt messages
 * @returns Array of placeholder names
 */
function extractPlaceholderNames(messages) {
    return messages
        .filter((msg) => msg.type === "placeholder" && typeof msg.name === "string")
        .map((msg) => msg.name);
}
